import { mobile } from '../../../mediaQueries'

const styles = theme => ({
    h1: {
        fontFamily: 'Playfair Display',
        fontSize: '48px',
        color: '#575452',
        fontWeight: '500',
        textAlign: 'center',
        letterSpacing: '0.02em',
        lineHeight: '67px',
        margin: 0,
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            padding: '0 16px',
            fontSize: '32px',
            lineHeight: '41px',
        }
    },
    h2: {
        fontFamily: 'Aktiv Grotesk',
        fontWeight: '400',
        textAlign: 'center',
        color: '#575452',
        fontSize: '1rem',
        lineHeight: '25.6px',
        letterSpacing: '0.01em',
        maxWidth: '80ch',
        margin: 'auto',
        marginTop: '24px',
        [theme.breakpoints.down(theme.breakpoints.values.xs + mobile)]: {
            padding: '0 1rem',
            maxWidth: '100%',
            marginBottom: '20px',
            fontSize: '14px',
            marginTop: '12px',
        }
    }
})

export default styles